<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="reconsider.data" [active]="reconsider.active"
                    [valueSelected]="reconsider.valueSelected"
                    (selectAnswer)="onReconsiderSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <select-question [data]="cacellation.data" [active]="reconsider.valueSelected !== 'n'"
                     [valueSelected]="cacellation.valueSelected"
                     (selectAnswer)="onCancellationSelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <explain-question [data]="explain.data" [active]="explain.active"
                      [valueSelected]="explain.valueSelected"
                      [validationSelected]="explain.validationSelected"
                      [validationText]="explain.validationText"
                      (selectAnswer)="onExplainQuestionSelected($event)"></explain-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
